module.exports = __webpack_public_path__ + "static/media/logo-design.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/logo-design.svg
// module id = 513
// module chunks = 0